import type { OverlayContextValue } from "@/components/modal/overlay.types";
import { createContext } from "react";

export const OverlayContext = createContext<OverlayContextValue | null>(null);
export const OverlayOwnerContext = createContext<string | null>(null);
